// @generated by rtk-query-codegen -- DO NOT EDIT
import { baseApi as api } from "../client/baseApi";
import type { CreateTicketResponse } from "../support/dto.generated";
export const addTagTypes = ["support"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postApiSupportTicket: build.mutation<
        PostApiSupportTicketApiResponse,
        PostApiSupportTicketApiArg
      >({
        query: (queryArg) => ({
          url: `/api/support/ticket`,
          method: "POST",
          body: queryArg.supportCreateTicketRequest,
        }),
        invalidatesTags: ["support"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as supportApi };
export type PostApiSupportTicketApiResponse =
  /** status 200 OK */ { data: SupportCreateTicketResponse };
export type PostApiSupportTicketApiArg = {
  /** Ticket details */
  supportCreateTicketRequest: SupportCreateTicketRequest;
};
export type SupportCreateTicketResponse = CreateTicketResponse;
export type SupportCreateTicketRequest = {
  area?: string;
  description?: string;
  email?: string;
  title?: string;
  type?: string;
  urgency?: string;
};
export const { usePostApiSupportTicketMutation } = injectedRtkApi;
